import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog, DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import SelectField from '../components/SelectField';
import TextField from '../components/TextField';
import { Content } from "../typings";
import { PrimaryButton, SecondaryButton } from "../components/buttons/Buttons";
import { Row } from "../components/Flex";

interface Props {
    open: boolean;
    contents: Content[];
    onClose: () => void;
    onAdd: (id: number, type: string) => void;
    onCreate: (name: string, type: string) => void;
}

function CreateDialog({ open, onClose, contents, onAdd, onCreate }: Props) {
    const [type, setType] = useState('PACKAGE');
    const [action, setAction] = useState('ADD');
    const [selectedId, setSelectedId] = useState<number>();
    const [name, setName] = useState<string>('');

    const packageOptions = contents
        .sort((a,b) => a.name.localeCompare(b.name))
        .filter(item => item.type === 'PACKAGE')
        .map(item => ({
        value: item.id,
        text: item.name
    }));
    const groupOptions = contents
        .sort((a,b) => a.name.localeCompare(b.name))
        .filter(item => item.type === 'GROUP')
        .map(item => ({
            value: item.id,
            text: item.name
        }));

    const onAddToGroup = () => {
        onAdd(selectedId!, type);
        setSelectedId(undefined);
        setName('');
    };

    const onCreateAction = () => {
        onCreate(name, type);
        setSelectedId(undefined);
        setName('');
    };

    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Add package or group
                    </DialogTitle>
                    <SelectField
                        label="Action"
                        value={action}
                        options={[
                            { value: 'ADD', text: 'Add existing' },
                            { value: 'CREATE', text: 'Create new' }
                        ]}
                        setValue={setAction}
                    />
                    <SelectField
                        label="Type"
                        value={type}
                        options={[
                            { value: 'PACKAGE', text: 'Package' },
                            { value: 'GROUP', text: 'Group' }
                        ]}
                        setValue={setType}
                    />
                    { action === 'CREATE' && <TextField label="Name" value={name} setValue={setName} /> }
                    { action === 'ADD' && type === 'PACKAGE' && (
                        <SelectField
                            label="Package"
                            placeholder="Select package"
                            value={selectedId}
                            options={packageOptions}
                            setValue={setSelectedId}
                        />
                    )}
                    { action === 'ADD' && type === 'GROUP' && (
                        <SelectField
                            label="Group"
                            placeholder="Select group"
                            value={selectedId}
                            options={groupOptions}
                            setValue={setSelectedId}
                        />
                    )}
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Add" onClick={action === 'ADD' ? onAddToGroup : onCreateAction} disabled={action === 'ADD' ? !selectedId : !name} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default CreateDialog;
